// crypto.randomUUID is missing on Safari < 15.4 and on non-HTTPS origins; a dozen call sites
// (toasts among them) assume it, and its absence crashed /analyze/ai-visibility/overview in prod.
if (typeof crypto !== "undefined" && typeof crypto.randomUUID !== "function") {
    (crypto as { randomUUID: () => string }).randomUUID = () =>
        "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
            (Number(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16)
        );
}

import("./bootstrap");

export {};
